export default function initHeroHp() {
    const body = document.querySelector('body');

    function updatePadding() {
        const container = document.querySelector('.hp-hero__foreground__container');
        const foreground = document.querySelector('.hp-hero__foreground');

        if (container) {
            if (window.innerWidth > 1024) {
                if (foreground) {
                    // Save the current scroll position
                    const scrollX = window.scrollX;
                    const scrollY = window.scrollY;

                    const childHeight = foreground.offsetHeight;
                    const foregroundTop = parseFloat(window.getComputedStyle(foreground).top);
                    container.style.paddingTop = `${childHeight + foregroundTop}px`;

                    // Restore the scroll position
                    window.scrollTo(scrollX, scrollY);
                }
            } else {
                container.style.paddingTop = '';
            }
        }
    }

    window.addEventListener('resize', updatePadding);
    window.addEventListener('load', updatePadding);

    updatePadding();
}